import type { User } from '@esf/shared';

/**
 * Demo users across the four tenants (Ping Group, Thompson Aero, Delta, AVIC).
 * Names and roles reflect realistic aviation programme functions; emails are
 * synthetic and route to non-existent mailboxes on the real corporate domains.
 */
export const demoUsers: User[] = [
  // --- ORG-001: Ping Group (platform host / operator) ---
  {
    email: 'admin@ubloquity.io',
    organisationId: 'ORG-001',
    role: 'SuperAdmin',
    name: 'Ubloquity Platform Admin',
    enabled: true,
    lastLoginAt: '2026-05-20T08:15:00.000Z',
    createdAt: '2024-01-15T09:00:00.000Z',
    updatedAt: '2026-05-20T08:15:00.000Z',
  },
  {
    email: 'd.mcallister@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'OrgAdmin',
    name: 'Diane McAllister',
    phoneNumber: '+44 7700 950101',
    enabled: true,
    lastLoginAt: '2026-05-21T09:30:00.000Z',
    createdAt: '2024-01-20T10:00:00.000Z',
    updatedAt: '2026-05-18T16:00:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-01-18T14:00:00.000Z',
  },
  {
    email: 'c.osullivan@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'AssetManager',
    name: "Cian O'Sullivan",
    phoneNumber: '+44 7700 950202',
    enabled: true,
    lastLoginAt: '2026-05-20T14:20:00.000Z',
    createdAt: '2024-02-05T11:00:00.000Z',
    updatedAt: '2026-05-20T14:20:00.000Z',
    invitedBy: 'd.mcallister@pinggroup.co.uk',
    invitedAt: '2024-02-03T09:00:00.000Z',
  },
  {
    email: 'n.devlin@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'FieldTech',
    name: 'Niamh Devlin',
    phoneNumber: '+44 7700 950303',
    enabled: true,
    lastLoginAt: '2026-05-21T07:00:00.000Z',
    createdAt: '2024-03-01T08:00:00.000Z',
    updatedAt: '2026-05-21T07:00:00.000Z',
    invitedBy: 'd.mcallister@pinggroup.co.uk',
    invitedAt: '2024-02-28T10:00:00.000Z',
  },
  {
    email: 'r.kelly@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'FieldTech',
    name: 'Ronan Kelly',
    phoneNumber: '+44 7700 950404',
    enabled: true,
    lastLoginAt: '2026-05-20T07:30:00.000Z',
    createdAt: '2024-03-15T08:30:00.000Z',
    updatedAt: '2026-05-20T07:30:00.000Z',
    invitedBy: 'd.mcallister@pinggroup.co.uk',
    invitedAt: '2024-03-13T11:00:00.000Z',
  },
  {
    email: 'a.morrison@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'Analyst',
    name: 'Aoife Morrison',
    enabled: true,
    lastLoginAt: '2026-05-19T10:00:00.000Z',
    createdAt: '2024-04-01T09:00:00.000Z',
    updatedAt: '2026-05-19T10:00:00.000Z',
    invitedBy: 'd.mcallister@pinggroup.co.uk',
    invitedAt: '2024-03-29T14:00:00.000Z',
  },
  {
    email: 'viewer@pinggroup.co.uk',
    organisationId: 'ORG-001',
    role: 'PublicViewer',
    name: 'Public Access',
    enabled: true,
    createdAt: '2024-04-15T12:00:00.000Z',
    updatedAt: '2024-04-15T12:00:00.000Z',
  },

  // --- ORG-002: Thompson Aero Seating ---
  {
    email: 'e.thompson@thompsonaero.com',
    organisationId: 'ORG-002',
    role: 'OrgAdmin',
    name: 'Eleanor Thompson',
    phoneNumber: '+44 7700 951010',
    enabled: true,
    lastLoginAt: '2026-05-21T09:00:00.000Z',
    createdAt: '2024-02-12T10:00:00.000Z',
    updatedAt: '2026-05-21T09:00:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-02-10T16:00:00.000Z',
  },
  {
    email: 'p.harrison@thompsonaero.com',
    organisationId: 'ORG-002',
    role: 'AssetManager',
    name: 'Paul Harrison',
    phoneNumber: '+44 7700 951020',
    enabled: true,
    lastLoginAt: '2026-05-20T16:00:00.000Z',
    createdAt: '2024-02-15T09:30:00.000Z',
    updatedAt: '2026-05-20T16:00:00.000Z',
    invitedBy: 'e.thompson@thompsonaero.com',
    invitedAt: '2024-02-13T11:00:00.000Z',
  },
  {
    email: 's.murphy@thompsonaero.com',
    organisationId: 'ORG-002',
    role: 'AssetManager',
    name: 'Sinead Murphy',
    phoneNumber: '+44 7700 951030',
    enabled: true,
    lastLoginAt: '2026-05-19T11:45:00.000Z',
    createdAt: '2024-03-05T09:00:00.000Z',
    updatedAt: '2026-05-19T11:45:00.000Z',
    invitedBy: 'e.thompson@thompsonaero.com',
    invitedAt: '2024-03-03T15:00:00.000Z',
  },
  {
    email: 'g.lambert@thompsonaero.com',
    organisationId: 'ORG-002',
    role: 'FieldTech',
    name: 'Gareth Lambert',
    phoneNumber: '+44 7700 951040',
    enabled: true,
    lastLoginAt: '2026-05-21T06:45:00.000Z',
    createdAt: '2024-03-20T08:00:00.000Z',
    updatedAt: '2026-05-21T06:45:00.000Z',
    invitedBy: 'e.thompson@thompsonaero.com',
    invitedAt: '2024-03-18T10:00:00.000Z',
  },
  {
    email: 'h.quinn@thompsonaero.com',
    organisationId: 'ORG-002',
    role: 'Analyst',
    name: 'Hannah Quinn',
    enabled: true,
    lastLoginAt: '2026-05-18T13:00:00.000Z',
    createdAt: '2024-04-10T09:00:00.000Z',
    updatedAt: '2026-05-18T13:00:00.000Z',
    invitedBy: 'e.thompson@thompsonaero.com',
    invitedAt: '2024-04-08T14:00:00.000Z',
  },

  // --- ORG-003: Delta Air Lines ---
  {
    email: 'j.bastian@delta.com',
    organisationId: 'ORG-003',
    role: 'OrgAdmin',
    name: 'Joel Bastian',
    phoneNumber: '+1 404 555 0110',
    enabled: true,
    lastLoginAt: '2026-05-20T15:30:00.000Z',
    createdAt: '2024-03-12T10:00:00.000Z',
    updatedAt: '2026-05-20T15:30:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-03-10T16:00:00.000Z',
  },
  {
    email: 'm.reeves@delta.com',
    organisationId: 'ORG-003',
    role: 'AssetManager',
    name: 'Monica Reeves',
    phoneNumber: '+1 404 555 0220',
    enabled: true,
    lastLoginAt: '2026-05-19T08:00:00.000Z',
    createdAt: '2024-04-05T09:30:00.000Z',
    updatedAt: '2026-05-19T08:00:00.000Z',
    invitedBy: 'j.bastian@delta.com',
    invitedAt: '2024-04-03T11:00:00.000Z',
  },
  {
    email: 'r.alvarez@delta.com',
    organisationId: 'ORG-003',
    role: 'AssetManager',
    name: 'Ricardo Alvarez',
    phoneNumber: '+1 404 555 0330',
    enabled: true,
    lastLoginAt: '2026-05-20T17:15:00.000Z',
    createdAt: '2024-04-22T09:00:00.000Z',
    updatedAt: '2026-05-20T17:15:00.000Z',
    invitedBy: 'j.bastian@delta.com',
    invitedAt: '2024-04-20T11:00:00.000Z',
  },

  // --- ORG-004: AVIC Cabin Systems ---
  {
    email: 'l.cheng@aviccabinsystems.com',
    organisationId: 'ORG-004',
    role: 'OrgAdmin',
    name: 'Linda Cheng',
    phoneNumber: '+44 20 7946 0010',
    enabled: true,
    lastLoginAt: '2026-05-15T10:30:00.000Z',
    createdAt: '2024-04-20T09:00:00.000Z',
    updatedAt: '2026-05-15T10:30:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-04-18T14:00:00.000Z',
  },
  {
    email: 'j.fletcher@aviccabinsystems.com',
    organisationId: 'ORG-004',
    role: 'Analyst',
    name: 'James Fletcher',
    enabled: true,
    lastLoginAt: '2026-05-12T15:00:00.000Z',
    createdAt: '2024-07-01T08:00:00.000Z',
    updatedAt: '2026-05-12T15:00:00.000Z',
    invitedBy: 'l.cheng@aviccabinsystems.com',
    invitedAt: '2024-06-28T10:00:00.000Z',
  },
];
